import useOktaQuery from './useOktaQuery';

const fetchBlob = async (oktaToken, src) => {
    const headers = { XFetchBlob: 1 };
    if (oktaToken && oktaToken.accessToken && oktaToken.tokenType) {
        headers.Authorization = `${oktaToken.tokenType} ${oktaToken.accessToken}`;
    }
    const resp = await fetch(src, {
        headers,
    });
    const blob = await resp.blob();
    return URL.createObjectURL(blob);
};

const useBlobDownloadQuery = (src) => {
    const obj = useOktaQuery(['image', src], (t) => fetchBlob(t, src), {
        cacheTime: Number.POSITIVE_INFINITY,
        enabled: src !== undefined,
        staleTime: 24 * 60 * 60 * 1000, // 1 day
    });
    return { ...obj, src: obj.data || '' };
};

export default useBlobDownloadQuery;
